
// // AppHeader.jsx - Header with integrated MessagesBell component
// import React from "react";
// import { useLocation } from "react-router-dom";
// import "./AppHeader.css";
// import MessagesBell from "./messages/MessagesBell"; // ⭐ Import the MessagesBell component

// const AppHeader = ({ isSidebarVisible, toggleSidebar }) => {
//   const location = useLocation();
//   const { pathname } = location;

//   // Keep your existing logic for search visibility if needed
//   const showSearchForMembers = pathname.includes("members");
//   const showSearchForEvents = pathname.includes("events");

//   // =====================================================
//   // Callback for MessagesBell - closes sidebar before opening messages
//   // =====================================================
//   const handleBeforeOpenMessages = () => {
//     if (isSidebarVisible) {
//       toggleSidebar();
//     }
//   };

//   return (
//     <header
//       className="app-header"
//       style={{
//         position: "fixed",
//         top: 0,
//         left: 0,
//         right: 0,
//         width: "100%",
//         zIndex: 1000,
//         backgroundColor: "#253866",
//         boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
//         height: "120px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "0 20px",
//       }}
//     >
//       {/* Inner container for absolutely positioned children */}
//       <div
//         style={{
//           position: "relative",
//           width: "100%",
//           height: "100%",
//         }}
//       >
//         {/* Centered Logo (toggles sidebar on click) */}
//         <div
//           onClick={toggleSidebar}
//           style={{
//             cursor: "pointer",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             height: "100%",
//             flexShrink: 0,
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//           }}
//         >
//           {/* <img
//             src="/images/onscreen.png"
//             alt="On Screen"
//             style={{
//               height: "55px",
//               width: "auto",
//               maxWidth: "210px",
//               objectFit: "contain",
//               display: "block",
//             }}
//           /> */}
//           <img
//             src="/images/on-screen-logo.png"
//             alt="On Screen"
//             style={{
//               height: "120px",
//               width: "auto",
//               maxWidth: "350px",
//               objectFit: "contain",
//               display: "block",
//             }}
//           />
//         </div>

//         {/* 
//           ⭐ Message Bell Component - fixed to top-right 
          
//           This MessagesBell component:
//           - Automatically turns ORANGE (#ff6800) when unread count > 0
//           - Automatically turns WHITE when unread count = 0
//           - Polls backend every 30 seconds for updated count
//           - Listens for real-time events (new-message, message-read, unread:refresh)
//           - Shows badge with count when there are unread messages
//           - Closes sidebar before opening messages modal
//         */}
//         <div
//           style={{
//             position: "absolute",
//             top: 0,
//             right: 0,
//             height: "100%",
//             display: "flex",
//             alignItems: "flex-start",
//             justifyContent: "flex-end",
//             flexShrink: 0,
//             paddingTop: "8px",
//             paddingRight: "8px",
//           }}
//         >
//           <MessagesBell 
//             size={28} 
//             onBeforeOpen={handleBeforeOpenMessages}
//           />
//         </div>
//       </div>
//     </header>
//   );
// };

// export default AppHeader;


// AppHeader.jsx - Header with integrated MessagesBell component
import React from "react";
import { useNavigate } from "react-router-dom";
import { FaEllipsisV } from "react-icons/fa";
import "./AppHeader.css";
import MessagesBell from "./messages/MessagesBell"; // ⭐ Import the MessagesBell component

const ICON_SIZE = 24;          // Material/IG/Twitter standard for app-bar icons
const LOGO_HEIGHT = 86;        // Scaled from 100 by the same 24/28 ratio as the icons
const HEADER_HEIGHT = 56;      // Industry standard mobile header (IG, Twitter, YouTube)

const AppHeader = ({ isSidebarVisible, toggleSidebar, hideMessagesBell = false, disableSidebarToggle = false }) => {
  const navigate = useNavigate();

  // =====================================================
  // Callback for MessagesBell - closes sidebar before opening messages
  // =====================================================
  const handleBeforeOpenMessages = () => {
    if (isSidebarVisible) {
      toggleSidebar();
    }
  };

  // Both the kebab and the logo open/close the sidebar (or fall back to /login
  // on public member pages where the sidebar isn't available).
  const handleSidebarTrigger = (e) => {
    e?.currentTarget?.blur?.();
    if (disableSidebarToggle) {
      navigate('/login');
    } else {
      toggleSidebar();
    }
  };

  const iconButtonStyle = {
    background: "transparent",
    border: "none",
    color: "#ffffff",
    padding: 4,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    outline: "none",
    boxShadow: "none",
    WebkitTapHighlightColor: "transparent",
  };

  return (
    <header
      className="app-header"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        width: "100%",
        zIndex: 1000,
        backgroundColor: "#253866",
        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        height: `${HEADER_HEIGHT}px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 12px",
        gap: "12px",
        overflow: "visible",
      }}
    >
      {/* Left: kebab menu — opens/closes the sidebar */}
      <button
        type="button"
        onClick={handleSidebarTrigger}
        aria-label={isSidebarVisible ? "Close menu" : "Open menu"}
        aria-expanded={!!isSidebarVisible}
        style={{ ...iconButtonStyle, width: ICON_SIZE + 8, height: ICON_SIZE + 8 }}
      >
        <FaEllipsisV size={ICON_SIZE} />
      </button>

      {/* Center: logo — also toggles the sidebar (or navigates to login on public pages) */}
      <button
        type="button"
        onClick={handleSidebarTrigger}
        aria-label="Toggle navigation menu"
        style={{
          background: "transparent",
          border: "none",
          padding: 0,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flex: "1 1 auto",
          minWidth: 0,
          outline: "none",
          boxShadow: "none",
          WebkitTapHighlightColor: "transparent",
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/on-screen-logo.png`}
          alt="On Screen"
          style={{
            height: `${LOGO_HEIGHT}px`,
            width: "auto",
            maxWidth: "100%",
            objectFit: "contain",
            display: "block",
            WebkitTransform: "translateZ(0)",
            transform: "translateZ(0)",
            backfaceVisibility: "hidden",
            WebkitBackfaceVisibility: "hidden",
            imageRendering: "-webkit-optimize-contrast",
          }}
          loading="eager"
          onError={(e) => {
            console.error("Logo failed to load:", e);
            e.target.style.display = "none";
          }}
        />
      </button>

      {/* Right: Message Bell — auto-orange on unread, opens messages modal */}
      {hideMessagesBell ? (
        // Spacer keeps the logo centered when the bell is hidden
        <div style={{ width: ICON_SIZE + 8, height: ICON_SIZE + 8 }} />
      ) : (
        <div style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
          <MessagesBell
            size={ICON_SIZE}
            onBeforeOpen={handleBeforeOpenMessages}
          />
        </div>
      )}
    </header>
  );
};

export default AppHeader;